import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {Address} from '@spartacus/core';
import {Observable} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {AddressUsage} from '@app/model/order/dcp-order-entry.model';
import {B2bUnitService} from '@app/services/b2b-unit.service';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {FeatureTogglesService} from '@dcp/configurator';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';

@UntilDestroy()
@Component({
  selector: 'dcp-company-details',
  styleUrls: ['./company-details.component.scss'],
  templateUrl: './company-details.component.html'
})
export class CompanyDetailsComponent implements OnInit {
  @Input() b2bUnitAddresses$: Observable<Address[]>;
  isShipToCheckboxChecked: boolean;
  isCreateNewLocationFeatureToggleEnabled: boolean;
  companyAddress: Address;
  detailsTitle = 'checkout.digitalNativeCheckout.companyDetails';
  shipToTitle = 'checkout.digitalNativeCheckout.primaryAccessLocation';
  shipToAddresses: Address[] = [];
  initialSelectedShipToAddress: number = 0;
  showMessage: boolean = false;
  isMouseOverSelectDifferentShipToFeatureToggleEnabled: boolean;
  private currentAddress: Address;
  readonly usageType = AddressUsage.SHIP_TO;

  constructor(
    private b2bUnitService: B2bUnitService,
    private cdr: ChangeDetectorRef,
    private dcpActiveCartService: DcpActiveCartService,
    private featureTogglesService: FeatureTogglesService) {
  }

  ngOnInit() {
    this.subscribeToCreateNewLocationFeatureToggle();
    this.subscribeToMouseOverSelectDifferentShipToFeatureToggle();
    this.b2bUnitAddresses$.pipe(untilDestroyed(this)).subscribe((b2bUnitAddresses: Address[]) => {
      this.companyAddress = b2bUnitAddresses.find((address: Address) => address.addressUsage.includes(AddressUsage.SOLD_TO));
      this.currentAddress = this.companyAddress;
      this.b2bUnitService.setCheckoutShipTo(this.currentAddress);
      this.shipToAddresses = b2bUnitAddresses.filter((address: Address) => address.addressUsage.includes(AddressUsage.SHIP_TO) && address.sapAddressUUID !== this.currentAddress.sapAddressUUID);
      this.cdr.detectChanges();
      this.dcpActiveCartService.getActiveCart().pipe(take(1), untilDestroyed(this)).subscribe((cart: Cart) => {
        const cartShipTo = cart.addresses.find((address) => address.addressUsage === 'SHIP_TO');
        const previouslySelected = this.shipToAddresses.find((shipToAddress) => shipToAddress.sapAddressUUID === cartShipTo.sapAddressUUID);
        if (previouslySelected) {
          this.initialSelectedShipToAddress = this.shipToAddresses.indexOf(previouslySelected);
          this.isShipToCheckboxChecked = true;
          this.showMessage = true;
          this.cdr.detectChanges();
        }
      });
      this.cdr.detectChanges();
    });
  }

  private subscribeToMouseOverSelectDifferentShipToFeatureToggle() {
    this.featureTogglesService.isEnabled(UNLEASH_TOGGLES.mouseOverSelectDifferentShipTo)
      .pipe(first(), untilDestroyed(this))
      .subscribe(enabled => this.isMouseOverSelectDifferentShipToFeatureToggleEnabled = enabled);
  }

  private subscribeToCreateNewLocationFeatureToggle() {
    this.featureTogglesService.isEnabled(UNLEASH_TOGGLES.createNewLocation)
      .pipe(first(), untilDestroyed(this))
      .subscribe(enabled => this.isCreateNewLocationFeatureToggleEnabled = enabled);
  }

  onKeyDown(): void {
    this.isShipToCheckboxChecked = !this.isShipToCheckboxChecked;
  };

  onChange($event: Event): void {
    const isDeselected = this.isCheckboxDeselected($event.target as HTMLInputElement)
    this.isShipToCheckboxChecked = !isDeselected;
    this.showMessage = !isDeselected;
    if (isDeselected) {
      this.b2bUnitService.setCheckoutShipTo(this.currentAddress);
    }
  }

  isCheckboxDeselected(event: HTMLInputElement): boolean {
    return !event.checked;
  }

  onAddressSelect($event: Address): void {
    this.b2bUnitService.setCheckoutShipTo($event);
  }
}
